const ARTICLE_PATTERN = /<article(?:\s[^>]*)?>([\s\S]*?)<\/article>/i;

export const createShopRuleArticle = (source: string) => {
  const article = source.match(ARTICLE_PATTERN)?.[1];

  if (!article) {
    throw new Error('萌铺规范内容缺少 article 节点');
  }

  const assetBase = `${import.meta.env.BASE_URL}shop-rules/assets/`;
  return article.replace(/src=(['"])assets\//g, `src=$1${assetBase}`);
};
